export default "__VITE_ASSET__CZIniv69__"